export default "__VITE_ASSET__8805d490__"